var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeSelect',_vm._g(_vm._b({attrs:{"load-options":_vm.getItems,"async":_vm.async,"loading":_vm.loading,"multiple":"","options":_vm.options,"label":_vm.label},scopedSlots:_vm._u([(_vm.$scopedSlots.label)?{key:"value-label",fn:function(){return [_vm._t("label")]},proxy:true}:null],null,true)},'TreeSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }